/*global page */
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'welcome';
  var pageManager = fc.pageManager;
  

  var currentPage = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);
  currentPage.maxStep = 3;
  currentPage.currentStep = 0;
  currentPage.redirectTo='/tutorial';
  
  currentPage.middleContent = ['<p class="upper">Hop your selfie in 4 easy steps</p><div class="middle" style="background-image:url(/assets/app/how1.png)"></div><p class="lower"><span>Snap a selfie</span></p>','<p class="upper">Hop your selfie in 4 easy steps</p><div class="middle" style="background-image:url(/assets/app/how2.png)"></div><p class="lower"><span>Check how SelfieHop removes the background</span></p>','<p class="upper">Hop your selfie in 4 easy steps</p><div class="middle" style="background-image:url(/assets/app/how3.png)"></div><p class="lower"><span>Pick your new surrounding</span></p>','<p class="upper">Hop your selfie in 4 easy steps</p><div class="middle" style="background-image:url(/assets/app/how4.png)"></div><p class="lower"><span>Save and share your awesome pic</span></p>'];

  currentPage.eventHandlers = fc.wizard.eventHandlers;

  currentPage.renderMiddle = fc.wizard.renderMiddle.bind(currentPage);

  currentPage.html = fc.wizard.getHtml(currentPage.redirectTo);

  currentPage.run = fc.wizard.run.bind(currentPage);

  pageManager.add(currentPage);

}(FakeCation));
